import { useState, useTransition } from "react"
import { PermitHeader } from "../../../Shared/components/PermitHeader"
import { IApproval } from "../models/Approval"
import { request } from "http"
import {jsPDF} from "jspdf"
import html2canvas from "html2canvas"
import { useTranslation } from "react-i18next"

export const Permit = (props:any) => {
    const [data,setData] = useState<any>(props.data)
    const {t} = useTranslation()
    const generatePDF = async (e: React.MouseEvent<HTMLButtonElement>) => {
        const element = document.getElementById('printable');
        if (!element) {
            throw new Error(`Element with id printable`);
        }
        const canvas = await html2canvas(element, { scale: 1 });
        const data = canvas.toDataURL("image/png");
        const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: [70,129],
        });
        const imgProperties = pdf.getImageProperties(data);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

        pdf.addImage(data, "PNG", 0, 0, pdfWidth, pdfHeight);
        const fileName = props.data?.contractNumber;
        pdf.save(`${fileName}.pdf`);
    };
    return (<>
        <div className="antialiased dark:bg-gray-900 mb-8r">
            <div className="mx-auto max-w-screen-lg px-4 2xl:px-0" id="printable">
                <div className="py-4">
                    <PermitHeader />
                </div>
                <table className="w-full mb-8">
                    <tbody>
                        <tr className="bg-primary-700 text-white flex justify-start items-center">
                            <td className="border-0 w-6/12 p-1">Nom du Transporteur (Carrier's Name)</td>
                            <td className="border-0 w-6/12 p-1">Contact (Contact Details)</td>
                        </tr>
                        <tr className="flex justify-start items-center border">
                            <td className="m-0 w-6/12">{data?.company?.name}</td>
                            <td className="border-0 m-0 w-6/12">
                                <div className="p-2 flex justify-start items-center border-b-2">
                                    <div className="w-6/12">Télephone (Phone)</div>
                                    <div className="w-6/12">Email</div>
                                </div>
                                <div className="p-2 flex justify-evenly items-center">
                                    <div className="w-6/12 border-e-2 border-e-gray-700">{data?.company?.profile?.contactFromPhone}</div>
                                    <div className="w-6/12">{data?.company?.profile?.contactFromEmail}</div>
                                </div>
                                
                            </td>
                        </tr>
                       <tr className="bg-primary-700 text-white flex justify-start items-center">
                            <td className="border-0 w-full p-1">Adresse du Transporteur (Carrier's Address)</td>
                        </tr>
                        <tr className="flex justify-start items-center border">
                            <td className="m-0 p-1">{data?.company?.address}, {data?.company?.country ? data?.company?.country : ''}</td>
                        </tr>
                        <tr className="bg-primary-700 text-white flex justify-start items-center">
                            <td className="border-0 w-6/12 p-1">Person à Contacter (Contact Person)</td>
                            <td className="border-0 w-6/12 p-1">Contact (Contact Details)</td>
                        </tr>
                        <tr className="flex justify-start items-center border">
                            <td className="m-0 w-6/12">{data?.company?.profile?.contactFromFullName}</td>
                            <td className="border-0 m-0 w-6/12">
                                <div className="p-2 flex justify-start items-center border-b-2">
                                    <div className="w-6/12">Télephone (Phone)</div>
                                    <div className="w-6/12">Email</div>
                                </div>
                                <div className="p-2 flex justify-evenly items-center">
                                    <div className="w-6/12 border-e-2 border-e-gray-700">{data?.company?.profile?.contactFromPhone}</div>
                                    <div className="w-6/12">{data?.company?.profile?.contactFromEmail}</div>
                                </div>
                                
                            </td>
                        </tr>
                        <tr className="bg-primary-700 text-white flex justify-start items-center">
                            <td className="border-0 w-6/12 p-1">Nom du Representent en RDC (Representative Name in DRC)</td>
                            <td className="w-6/12 p-1">Contact (Contact Details)</td>
                        </tr>
                        <tr className="flex justify-start items-center border">
                            <td className="m-0 w-6/12">{data?.company?.profile?.contactToFullName}</td>
                            <td className="border-0 m-0 w-6/12">
                                <div className="p-2 flex justify-start items-center border-b-2">
                                    <div className="w-6/12">Télephone (Phone)</div>
                                    <div className="w-6/12">Email</div>
                                </div>
                                <div className="p-2 flex justify-evenly items-center">
                                    <div className="w-6/12 border-e-2 border-e-gray-700">{data?.company?.profile?.contactToPhone}</div>
                                    <div className="w-6/12">{data?.company?.profile?.contactToEmail}</div>
                                </div>
                                
                            </td>
                        </tr>
                         <tr className="bg-primary-700 text-white flex justify-start items-center">
                            <td className="border-0 w-full p-1">Adresse du Representent en RDC (DRC Representative's Address)</td>
                        </tr>
                        <tr className="flex justify-start items-center border">
                            <td className="m-0 p-1">{data?.company?.profile?.contactToAddress}</td>
                        </tr>
                         <tr className="bg-primary-700 text-white flex justify-start items-center">
                            <td className="border-0 w-full p-1">Numéro du Contrat (Contract Number)</td>
                        </tr>
                        <tr className="flex justify-start items-center border">
                            <td className="m-0 p-1">{data?.contractNumber}</td>
                        </tr>
                         <tr className="bg-primary-700 text-white flex justify-start items-center">
                            <td className="border-0 w-4/12 p-1">Nombre de Camions (No. of Trucks)</td>
                            <td className="border-0 w-4/12 p-1">Itinéraire (Allowed Route)</td>
                            <td className="border-0 w-4/12 p-1">Marchandise (Allowed Goods)</td>
                        </tr>
                        <tr className="flex justify-start items-center border">
                            <td className="m-0 p-1 w-4/12">{data?.company?.vehicleCount}</td>
                            <td className="m-0 p-1 w-4/12">{data?.authorizedRoute}</td>
                            <td className="m-0 p-1 w-4/12">{data?.authorizedGoods}</td>
                        </tr>
                         <tr className="bg-primary-700 text-white flex justify-start items-center">
                            <td className="border-0 w-6/12 p-1">Date d'Emission (Date of issue)</td>
                            <td className="border-0 w-6/12 p-1">Lieu d'Emission (Place of issue)</td>
                        </tr>
                        <tr className="flex justify-start items-center border">
                            <td className="m-0 p-1 w-6/12">{data?.validFrom}</td>
                            <td className="m-0 p-1 w-6/12">Kinshasa, DRC</td>
                        </tr>
                         <tr className="bg-primary-700 text-white flex justify-start items-center">
                            <td className="border-0 w-6/12 p-1">Valide à partir du (Valid from)</td>
                            <td className="border-0 w-6/12 p-1">Valide Jusqu'à (Valid until)</td>
                        </tr>
                        <tr className="flex justify-start items-center border">
                            <td className="m-0 p-1 w-6/12">{data?.validFrom}</td>
                            <td className="m-0 p-1 w-6/12">{data?.validUntil}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <button onClick={generatePDF} className="btn text-white bg-blue-500 px-4 py-2 my-4">{t('print')}</button>
        </div>
    </>)
}